"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRelatedComponents = exports.getComponentToken = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _token = _interopRequireDefault(require("antd/es/version/token.json"));
var tokenRelatedComponents = {};
var getRelatedComponentsSingle = function getRelatedComponentsSingle(token) {
  var _tokenRelatedComponen;
  if (!tokenRelatedComponents[token]) {
    tokenRelatedComponents[token] = Object.entries(_token.default).filter(function (_ref) {
      var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
        tokens = _ref2[1];
      return tokens.global.includes(token);
    }).map(function (_ref3) {
      var _ref4 = (0, _slicedToArray2.default)(_ref3, 1),
        component = _ref4[0];
      return component;
    });
  }
  return (_tokenRelatedComponen = tokenRelatedComponents[token]) !== null && _tokenRelatedComponen !== void 0 ? _tokenRelatedComponen : [];
};
var getRelatedComponents = exports.getRelatedComponents = function getRelatedComponents(token) {
  var mergedTokens = Array.isArray(token) ? token : [token];
  return Array.from(new Set(mergedTokens.reduce(function (result, item) {
    return result.concat(getRelatedComponentsSingle(item));
  }, [])));
};
var getComponentToken = exports.getComponentToken = function getComponentToken(component) {
  return _token.default[component];
};